import React, { useState, useRef } from 'react';
import { BsXLg, BsPlus, BsChevronDown, BsChevronUp } from "react-icons/bs";
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import '../../style/FilterComponent.scss'

const FilterComponent = props => {
    const { t } = useTranslation();
    const { filters, setActiveFilters } = props
    const query = useQuery();
    const defaultFilter = JSON.parse(atob(query.get("filter") ?? 'e30K'));
    const [isMenuOpen, setMenuOpen] = useState(false);
    const [selectedItems, setSelectedItems] = useState(defaultFilter);
    const [openDropdown, setOpenDropdown] = useState(null);
    const priceFromRef = useRef(null);
    const priceToRef = useRef(null);
    const [priceRange, setPriceRange] = useState('*:*');

    const handleInputChange = () => {
        // Let the DOM update before reading values
        const min = priceFromRef.current?.value || '*';
        const max = priceToRef.current?.value || '*';

        const newRange = `${min}:${max}`;
        setPriceRange(newRange);

        selectedItems['price'] = newRange;
        const filter = btoa(JSON.stringify(selectedItems));
        window.history.replaceState(null, window.title, document.location.pathname + '?filter=' + filter);
        setActiveFilters(filter);
    };

    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    const sortFilterItems = (items, filterKey) => {
        const sorted = (items ?? []).slice();
    
        if (filterKey === 'size') {
            const getSortValue = (val) => {
                const str = Array.isArray(val) ? val[1] : val;
                const match = str.match(/^(\d+(\.\d+)?)/);
                return match ? parseFloat(match[0]) : null;
            };
    
            sorted.sort((aRaw, bRaw) => {
                const aLabel = Array.isArray(aRaw) ? aRaw[1] : aRaw;
                const bLabel = Array.isArray(bRaw) ? bRaw[1] : bRaw;
                const aValue = getSortValue(aLabel);
                const bValue = getSortValue(bLabel);
    
                if (aValue !== null && bValue !== null) {
                    return aValue - bValue;
                } else if (aValue !== null) {
                    return -1;
                } else if (bValue !== null) {
                    return 1;
                } else {
                    return aLabel.localeCompare(bLabel);
                }
            });
        } else {
            sorted.sort((a, b) => {
                const nameA = Array.isArray(a) ? a[1] : a;
                const nameB = Array.isArray(b) ? b[1] : b;
                return nameA.localeCompare(nameB);
            });
        }
    
        return sorted;
    };

    // Array of items to display in the dropdown
    const dropdownData = [
        {
            title: 'Kategori',
            filterKey: 'categoriesId',
            items: sortFilterItems(filters.categoriesId, 'categoriesId')
        },
        {
            title: 'Material',
            filterKey: 'materialsId',
            items: sortFilterItems(filters.materialsId, 'materialsId')
        },
        {
            title: 'Färg',
            filterKey: 'color',
            items: sortFilterItems(filters.color, 'color')
        },
        {
            title: 'Storlek',
            filterKey: 'size',
            items: sortFilterItems(filters.size, 'size')
        }
    ];

    // Function to toggle the menu
    const toggleMenu = () => {
        setMenuOpen(!isMenuOpen);
    };

    const toggleDropdown = (index) => {
        setOpenDropdown(openDropdown === index ? null : index);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            setMenuOpen(false);
        }
    };

    // Function to handle checkbox selection
    const handleCheckboxChange = (item, filterKey) => {
        if(!Array.isArray(item)) {
            item = [item];
        }
        if (selectedItems[filterKey] !== undefined && selectedItems[filterKey].includes(item[0])) {
            selectedItems[filterKey] = selectedItems[filterKey].filter((i) => i !== item[0])
            if (selectedItems[filterKey].length === 0) {
                delete selectedItems[filterKey];
            }
        } else {
            if (selectedItems[filterKey] === undefined) {
                selectedItems[filterKey] = [];
            }
            selectedItems[filterKey].push(item[0]);
        }
        setSelectedItems(selectedItems); // Add item to the selection

        selectedItems['price'] = priceRange;
        const filter = btoa(JSON.stringify(selectedItems));
        window.history.replaceState(null, window.title, document.location.pathname + '?filter=' + filter);
        setActiveFilters(filter);
    };

    return (
        <div className='product-filter-container'>
            {/* Filter button */}
            <button className="product-filter-button" onClick={toggleMenu}>
                {t('pim-filterTitleShort')} <BsPlus />
            </button>

            {/* Side menu */}
            <div className={`product-filter-side-menu ${isMenuOpen ? 'open' : ''}`}>
                <div className="product-filter-menu-header">
                    <h2>{t('pim-filterTitle')}</h2>
                    <BsXLg onClick={toggleMenu} className="close-button" />
                </div>
                {/* Menu content */}
                <div className="menu-content">
                    <p>Filtrera på pris</p>
                    <div className="input-row">
                        <div className="input-group">
                            <input
                                type="text"
                                id="from"
                                placeholder="Från"
                                ref={priceFromRef}
                                onInputCapture={handleInputChange}
                                onKeyDown={handleKeyDown}
                            />
                        </div>

                        <div className="input-group">
                            <input
                                type="text"
                                id="to"
                                placeholder="Till"
                                ref={priceToRef}
                                onInputCapture={handleInputChange}
                                onKeyDown={handleKeyDown}
                            />
                        </div>
                    </div>
                </div>
                {/* Dropdown checklist */}
                <div className="product-filter-dropdown">
                    {dropdownData.map((group, groupIndex) => (
                        <div key={groupIndex}>
                            <button className="product-filter-dropdown-button" onClick={() => toggleDropdown(groupIndex)}>
                                {group.title}
                                {openDropdown === groupIndex ? (
                                    <BsChevronUp className="arrow" />
                                ) : (
                                    <BsChevronDown s className="arrow" />
                                )}
                            </button>

                            {/* Dropdown items */}
                            {openDropdown === groupIndex && (
                                <div className="product-filter-dropdown-menu">
                                    {group.items.map((item, itemIndex) => (
                                        <div key={groupIndex} className="product-filter-dropdown-item">
                                            <input
                                                type="checkbox"
                                                id={`checkbox-${groupIndex}-${itemIndex}`}
                                                checked={selectedItems?.[group.filterKey]?.includes(Array.isArray(item) ? item[0] : item)}
                                                onChange={() => handleCheckboxChange(item, group.filterKey)}
                                            />
                                            <label htmlFor={`checkbox-${groupIndex}-${itemIndex}`}>{Array.isArray(item) ? item[1] : item}</label>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
                <div className="clear-button-container">
                    <button className="clear-button"
                        onClick={() => {
                            const clearedFilters = {};
                            setSelectedItems(clearedFilters);
                            setActiveFilters(btoa(JSON.stringify(clearedFilters)));

                            if (priceFromRef.current) priceFromRef.current.value = '';
                            if (priceToRef.current) priceToRef.current.value = '';
                            
                            setPriceRange('*:*');
                        }}>
                        {t('shop-AddressClear')}
                    </button>
                </div>

            </div>
            {isMenuOpen && <div className="overlay" onClick={toggleMenu}></div>}
        </div>
    );
};


export default FilterComponent;
